export const ALMACEN = {
    GESTION_ARTICULOS: {
        FindMaterialsViewPaged: 'Services/WareHouse/MaterialService.svc/FindMaterialsViewPaged',
        GetAllValidBrands: 'Services/WareHouse/WareHouseMaterialService.svc/GetAllValidBrands',
        purchaseDiscountsGetAll: 'Services/WareHouse/PurchaseDiscountsService.svc/GetAll',
        AccountingCodesGetAll: 'Services/WareHouse/AccountingCodesService.svc/GetAll',
        EcoTaxesGetAll: 'Services/WareHouse/EcoTaxesService.svc/GetAll',
        MaterialIndexesGetAll: 'Services/WareHouse/MaterialIndexesService.svc/GetAll',
        GetAllMovementWareHouseCode: 'Services/WareHouse/WareHousesService.svc/GetAllMovementWareHouseCode',
        GetMeasureUnits: 'Services/WareHouse/WareHouseMaterialService.svc/GetMeasureUnits',
        GetAllSuppliers: 'Services/General/CustomerService.svc/GetAllSuppliers',
        GetCmbSuppliers: 'Services/General/CustomerService.svc/GetCmbSuppliers',
        VatTypeServiceGetAll: 'Services/General/VatTypeService.svc/GetAll',
        BrandMaterialGetAll: 'Services/WareHouse/BrandMaterialService.svc/GetAll',
        FindPagedForImport: 'Services/WareHouse/BrandMaterialService.svc/FindPagedForImport',
        ComboCodigoContable: 'Services/WareHouse/AccountingCodesService.svc/GetAll',
        SearchSegment: 'Services/WareHouse/MaterialSegmentsService.svc/GetByIndexCode',
        SearchCrenau: 'Services/WareHouse/CrenauCodeService.svc/GetBySegmentCode',
        SearchFamily: 'Services/WareHouse/MarketingFamiliesService.svc/GetByCrenauCode',
        GetByDiscountCode: 'Services/WareHouse/PurchaseDiscountsService.svc/GetByDiscountCode',
        UpdateMaterialWareHousePosition: 'Services/WareHouse/WareHouseMaterialService.svc/UpdateMaterialWareHousePosition',
        addMaterial: 'Services/WareHouse/WareHouseMaterialService.svc/Add',
        updateMaterial: 'Services/WareHouse/WareHouseMaterialService.svc/Update',
        GetByMaterialCode: 'Services/WareHouse/WareHouseMaterialService.svc/GetByMaterialCode ',
        GetByMaterialCodeWithDetails: 'Services/WareHouse/WareHouseMaterialService.svc/GetByMaterialCodeWithDetails',
        GetReplacementsForMaterialImport: 'Services/WareHouse/BrandMaterialService.svc/GetReplacementsForMaterialImport',
        GetWareHouseMovementsByCode: 'Services/WareHouse/WareHousesService.svc/GetWareHouseMovementsByCode',
        ReactivateByID: 'Services/WareHouse/WareHouseMaterialService.svc/ReactivateByID',
        CampaignService: 'Services/WareHouse/CampaignService.svc/GetByMaterialCode',
        GetCurrentMovementsForMaterialByCode: 'Services/WareHouse/WareHouseMaterialService.svc/GetCurrentMovementsForMaterialByCode',
        FindByCodeAndDescriptionPaged: 'Services/WareHouse/BrandMaterialService.svc/FindByCodeAndDescriptionPaged'
    },
    PEDIDOS_PIEZAS: {
        GetMaterialEntries: 'Services/WareHouse/MaterialEntriesService.svc/GetMaterialEntries',
        GetSupplierOrdersForMaterialEntry: 'Services/WareHouse/MaterialEntriesService.svc/GetSupplierOrdersForMaterialEntry',
        GetMaterialEntryByID: 'Services/WareHouse/MaterialEntriesService.svc/GetMaterialEntryByID',
        GetSupplierOrderByNumberComplete: 'Services/WareHouse/OrderSupplierService.svc/GetSupplierOrderByNumberComplete',
        FindMaterialsPaged: 'Services/WareHouse/WareHouseMaterialService.svc/FindMaterialsPaged',
        GetByMaterialCodeWithDetails: 'Services/WareHouse/WareHouseMaterialService.svc/GetByMaterialCodeWithDetails',
        GetByDiscountCode: 'Services/WareHouse/PurchaseDiscountsService.svc/GetByDiscountCode',
        GetSaleDiscount: 'Services/WareHouse/SaleDiscountsService.svc/GetSaleDiscount',
        FindSuppliersPaged: 'Services/WareHouse/WareHousesService.svc/FindSuppliersPaged',
        GetByCustomerCode: 'Services/General/CustomerService.svc/GetByCustomerCode',
        AddMaterialOrder: 'Services/WareHouse/OrderSupplierService.svc/AddMaterialOrder',
        AddMaterialReplacementsOrder: 'Services/WareHouse/OrderSupplierService.svc/AddMaterialReplacementsOrder',
        RemoveMaterialOrder: 'Services/WareHouse/OrderSupplierService.svc/RemoveMaterialOrderByID',
        CancelSupplierOrder: 'Services/WareHouse/OrderSupplierService.svc/CancelSupplierOrder',
        ModificarMaterialOrderByID: 'Services/WareHouse/OrderSupplierService.svc/ModificarMaterialOrderByID',
        GetAllSupplierOrdersCount: 'Services/WareHouse/OrderSupplierService.svc/GetAllSupplierOrdersCount',
        GetInProgressSupplierOrdersPaged: 'Services/WareHouse/OrderSupplierService.svc/GetInProgressSupplierOrdersPaged',
        GetAcceptedSupplierOrdersPaged: 'Services/WareHouse/OrderSupplierService.svc/GetAcceptedSupplierOrdersPaged',
        GetPartiallyServedSupplierOrdersPaged: 'Services/WareHouse/OrderSupplierService.svc/GetPartiallyServedSupplierOrdersPaged',
        GetServedSupplierOrdersPaged: 'Services/WareHouse/OrderSupplierService.svc/GetServedSupplierOrdersPaged',
        GetClosedSupplierOrdersPaged: 'Services/WareHouse/OrderSupplierService.svc/GetClosedSupplierOrdersPaged',
    },
    VENTAS_MOSTRADOR: {
        GetAllCustomer: 'Services/General/CustomerService.svc/GetAllCustomer',
        GetCompanyConfiguration: 'Services/General/WorkshopConfigurationsService.svc/GetCompanyConfiguration',
        GetComboDepartamentos: 'Services/Workshop/InternalSectionsService.svc/GetAll',
        GetComboEmpleados: 'Services/General/EmployeeService.svc/GetAll',
        GetComboRecepcionistas: 'Services/WareHouse/ReceptionistService.svc/GetAll',
        // GetComboTiposPago: 'Services/General/PaymentTypesService.svc/Find',
        GetComboTiposPago: 'Services/General/PaymentTypesService.svc/GetByType',
        GetComboSectorTaller: 'Services/Workshop/WorkingSectionService.svc/GetAllWorkingSections',
        searchOR: 'Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete',
        GetNewDocumentNumber: 'Services/WareHouse/CounterSalesService.svc/GetNewDocumentNumber',
        OpenNewCounterSale: 'Services/WareHouse/CounterSalesService.svc/OpenNewCounterSale',
        OpenNewCounterSaleAmendmentByParams: 'Services/WareHouse/CounterSalesService.svc/OpenNewCounterSaleAmendmentByParams',
        OpenNewCounterSaleAmendmentSimulatedByParams: 'Services/WareHouse/CounterSalesService.svc/OpenNewCounterSaleAmendmentSimulatedByParams',
        FinishCreditCounterSaleByParams: 'Services/WareHouse/CounterSalesService.svc/FinishCreditCounterSaleByParams',
        FinishCashCounterSaleByParams: 'Services/WareHouse/CounterSalesService.svc/FinishCashCounterSaleByParams',
        UpdateProductionOrderHeaderVM: 'Services/Workshop/RepairOrderService.svc/UpdateProductionOrderHeaderVM',
        UpdateCounterSale: 'Services/WareHouse/CounterSalesService.svc/UpdateCounterSale',
        GetAllDocumentClasses: 'Services/General/DocumentPrefixesService.svc/GetAllDocumentClasses',
        STEP1: {
            GetVmEnCurso: 'Services/WareHouse/CounterSalesService.svc/GetInProgressCounterSales',
            GetCounterSaleComplete: 'Services/WareHouse/CounterSalesService.svc/GetCounterSaleComplete',
            GetInvoicesByDocumentWithDetails: 'Services/Invoicing/SalesInvoicesService.svc/GetInvoicesByDocumentWithDetails',
            GetAllCounterSalesCount: 'Services/WareHouse/CounterSalesService.svc/GetAllCounterSalesCount',
            GetVmPendientesFacturar: 'Services/WareHouse/CounterSalesService.svc/GetPendingBillCounterSales',
            GetCounterSaleAmendMentComplete: 'Services/WareHouse/CounterSalesService.svc/GetCounterSaleAmendMentComplete',

            GetVmFacturadas: 'Services/WareHouse/CounterSalesService.svc/GetBilledCounterSales',
            GetVmAnuladas: 'Services/WareHouse/CounterSalesService.svc/GetCanceledCounterSales',

            CancelCounterSaleByParams: 'Services/WareHouse/CounterSalesService.svc/CancelCounterSaleByParams'
        },
        STEP3: {
            ImputarMaterialOR: 'Services/Workshop/RepairOrderService.svc/ImputarMaterial',
            ImputarMaterial: 'Services/WareHouse/CounterSalesService.svc/ImputarMaterial',
            ModificarImputacionMaterialByID: 'Services/WareHouse/CounterSalesService.svc/ModificarImputacionMaterialByID',
            ModificarMaterialByID: 'Services/Workshop/RepairOrderService.svc/ModificarMaterialByID',
            EliminarImputacionMaterialByID: 'Services/WareHouse/CounterSalesService.svc/EliminarImputacionMaterialByID',
            EliminarMaterialByID: 'Services/Workshop/RepairOrderService.svc/EliminarMaterialByID',
            ImputarPiezaSinFicha: 'Services/WareHouse/CounterSalesService.svc/ImputarPiezaSinFicha',
            UpdateImputacionPiezaSinFicha: 'Services/WareHouse/CounterSalesService.svc/UpdateImputacionPiezaSinFicha',
            EliminarPiezaSinFichaById: 'Services/WareHouse/CounterSalesService.svc/EliminarPiezaSinFichaById',
        },
        STEP4: {
            FinishCashCounterSaleSimulated: 'Services/WareHouse/CounterSalesService.svc/FinishCashCounterSaleSimulated',
            FinishCreditCounterSaleSimulated: 'Services/WareHouse/CounterSalesService.svc/FinishCreditCounterSaleSimulated',
        }
    },
    CORRECCION_STOCK: {
        GetMeasureUnits: 'Services/WareHouse/WareHouseMaterialService.svc/GetMeasureUnits',
        GetById: 'Services/WareHouse/StockCorrectionService.svc/GetByID',
        CloseMaterialInventoryByID: 'Services/WareHouse/StockCorrectionService.svc/CloseMaterialInventoryByID',
        DeleteByid: 'Services/WareHouse/StockCorrectionService.svc/DeleteByID',
        STEP1: {
            GetOpenedMaterialInventories: 'Services/WareHouse/StockCorrectionService.svc/GetOpenedMaterialInventories',
            GetClosedMaterialInventories: 'Services/WareHouse/StockCorrectionService.svc/GetClosedMaterialInventories'
        },
        STEP2: {
            AddNewStockCorrection: 'Services/WareHouse/StockCorrectionService.svc/AddNewStockCorrection',
            addDetail: 'Services/WareHouse/StockCorrectionService.svc/AddDetail',
            deleteDetail: 'Services/WareHouse/StockCorrectionService.svc/DeleteDetail',
            updateDetail: 'Services/WareHouse/StockCorrectionService.svc/UpdateDetail'
        }
    },
    ENTRADAS_ALMACEN: {
        CloseMaterialEntry: 'Services/WareHouse/MaterialEntriesService.svc/CloseMaterialEntry',
        GetMaterialEntryByID: 'Services/WareHouse/MaterialEntriesService.svc/GetMaterialEntryByID',
        DeleteMaterialEntryByID: 'Services/WareHouse/MaterialEntriesService.svc/DeleteMaterialEntryByID',
        GetOpenedMaterialEntries: 'Services/WareHouse/MaterialEntriesService.svc/GetOpenedMaterialEntries',
        GetAllMaterialEntriesCount: 'Services/WareHouse/MaterialEntriesService.svc/GetAllMaterialEntriesCount',
        GetClosedMaterialEntries: 'Services/WareHouse/MaterialEntriesService.svc/GetClosedMaterialEntries',
        GetBilledMaterialEntries: 'Services/WareHouse/MaterialEntriesService.svc/GetBilledMaterialEntries',
        GetSupplierOrdersForMaterialEntry: 'Services/WareHouse/MaterialEntriesService.svc/GetSupplierOrdersForMaterialEntry',
        GetSupplierOrderByNumberComplete: 'Services/WareHouse/OrderSupplierService.svc/GetSupplierOrderByNumberComplete',
        GetAllReceptionists: 'Services/WareHouse/ReceptionistService.svc/GetAllReceptionists',
        GetAllReceptionistsService: 'Services/WareHouse/ReceptionistService.svc/GetAll',
        GetAll: 'Services/General/PaymentTypesService.svc/GetAll',
        ExistsEntryMaterialByDocumentData: 'Services/WareHouse/MaterialEntriesService.svc/ExistsEntryMaterialByDocumentData',
        OpenNewMaterialEntry: 'Services/WareHouse/MaterialEntriesService.svc/OpenNewMaterialEntry',
        UpdateMaterialEntryByParams: 'Services/WareHouse/MaterialEntriesService.svc/UpdateMaterialEntryByParams',
        CloseMaterialEntryWithDetail: 'Services/WareHouse/MaterialEntriesService.svc/CloseMaterialEntryWithDetail',
        CloseSupplierOrderByParams: 'Services/WareHouse/OrderSupplierService.svc/CloseSupplierOrderByParams',
        ImputarMaterialDetail: 'Services/WareHouse/MaterialEntriesService.svc/ImputarMaterialDetail',
        ImputarMaterialDetailByID: 'Services/WareHouse/MaterialEntriesService.svc/ImputarMaterialDetailByID',
        DeleteMaterialDetailByID: 'Services/WareHouse/MaterialEntriesService.svc/DeleteMaterialDetailByID',
        CloseMaterialEntryByID: 'Services/WareHouse/MaterialEntriesService.svc/CloseMaterialEntryByID',
        GetFileInfoEQ0093: 'Services/Brand/PartsOrderService.svc/GetFileInfoEQ0093',
        ReOpenMaterialEntryWithDetail: 'Services/WareHouse/MaterialEntriesService.svc/ReOpenMaterialEntryWithDetail'
    },
    PRESUPUESTOS_VM: {
        STEP1: {
            GetPvmEnCurso: 'Services/WareHouse/CounterSalesBudgetService.svc/GetOpenedBudgetsPaged',
            GetPvmCerrado: 'Services/WareHouse/CounterSalesBudgetService.svc/GetClosedBudgetsPaged',
            GetPvmAceptado: 'Services/WareHouse/CounterSalesBudgetService.svc/GetAcceptedBudgetsPaged',
            GetPvmRechazado: 'Services/WareHouse/CounterSalesBudgetService.svc/GetRejectBudgetsPaged',
            GetRepairOrderByIdCompleteVM: 'Services/WareHouse/CounterSalesBudgetService.svc/GetByProductionOrderNumberComplete',
            RejectBudgetByParams: 'Services/WareHouse/CounterSalesBudgetService.svc/RejectBudgetByParams',
            AcceptBudgetByParams: 'Services/WareHouse/CounterSalesBudgetService.svc/AcceptBudgetByParams',
            CancelBudgetByParams: 'Services/WareHouse/CounterSalesBudgetService.svc/CancelBudgetByParams',
            ReOpenBudgetByParams: 'Services/WareHouse/CounterSalesBudgetService.svc/ReOpenBudgetByParams'
        },
        STEP2: {
            GetNewDocumentNumber: 'Services/WareHouse/CounterSalesBudgetService.svc/GetNewDocumentNumber',
            UpdateBudget: 'Services/WareHouse/CounterSalesBudgetService.svc/UpdateBudget',
            OpenNewBudget: 'Services/WareHouse/CounterSalesBudgetService.svc/OpenNewBudget'
        },
        STEP3: {
            ImputarMaterial: 'Services/WareHouse/CounterSalesBudgetService.svc/ImputarMaterial',
            ModificarImputacionMaterialByID: 'Services/WareHouse/CounterSalesBudgetService.svc/ModificarImputacionMaterialById',
            EliminarImputacionMaterialByID: 'Services/WareHouse/CounterSalesBudgetService.svc/EliminarImputacionMaterialByID',
            ImputarPiezaSinFicha: 'Services/WareHouse/CounterSalesBudgetService.svc/ImputarPiezaSinFicha',
            UpdateImputacionPiezaSinFicha: 'Services/WareHouse/CounterSalesBudgetService.svc/UpdateImputacionPiezaSinFicha',
            EliminarPiezaSinFichaById: 'Services/WareHouse/CounterSalesBudgetService.svc/EliminarPiezaSinFichaById',
        },
        STEP4: {
            GetAllReceptionists: 'Services/WareHouse/ReceptionistService.svc/GetAllReceptionists',
            CloseBudgetByParamsSimulated: 'Services/WareHouse/CounterSalesBudgetService.svc/CloseBudgetByParamsSimulated',
            CloseBudgetByParams: 'Services/WareHouse/CounterSalesBudgetService.svc/CloseBudgetByParams'
        }
    },
    MANTENIMIENTO: {
        MARKETING_FAMILIAS: {
            MarketingFamiliesGetAll: 'Services/WareHouse/MarketingFamiliesService.svc/GetAll',
            MarketingFamiliesUpdate: 'Services/WareHouse/MarketingFamiliesService.svc/Update',
            MarketingFamiliesDelete: 'Services/WareHouse/MarketingFamiliesService.svc/Delete',
            MarketingFamiliesAdd: 'Services/WareHouse/MarketingFamiliesService.svc/Add',

        },
        INDICE: {
            IndiceGetAll: 'Services/WareHouse/MaterialIndexesService.svc/GetAll',
            IndiceUpdate: 'Services/WareHouse/MaterialIndexesService.svc/Update',
            IndiceDelete: 'Services/WareHouse/MaterialIndexesService.svc/Delete',
            IndiceAdd: 'Services/WareHouse/MaterialIndexesService.svc/Add',
        },
        SEGMENTO: {
            SegmentoGetAll: 'Services/WareHouse/MaterialSegmentsService.svc/GetAll',
            SegmentoUpdate: 'Services/WareHouse/MaterialSegmentsService.svc/Update',
            SegmentoDelete: 'Services/WareHouse/MaterialSegmentsService.svc/Delete',
            SegmentoAdd: 'Services/WareHouse/MaterialSegmentsService.svc/Add',
            SegmentoIndexGetAll: 'Services/WareHouse/MaterialIndexesService.svc/GetAll'
        },
        DESCUENTO_VENTAS: {
            SalesDiscountsGetAll: 'Services/WareHouse/SaleDiscountsService.svc/GetAll',
            SalesDiscountsUpdate: 'Services/WareHouse/SaleDiscountsService.svc/Update',
            SalesDiscountsDelete: 'Services/WareHouse/SaleDiscountsService.svc/Delete',
            SalesDiscountsAdd: 'Services/WareHouse/SaleDiscountsService.svc/Add',
            BrandCodesGetAll: 'Services/WareHouse/BrandCodesService.svc/GetAll',
            CustomerPRDiscountsGetAll: 'Services/General/CustomerPRDiscountsService.svc/GetAll'
        },
        GESTION_ECOTASAS: {
            ManagmentEcotasasGetAll: 'Services/WareHouse/EcoTaxesService.svc/GetAll',
            ManagmentEcotasasUpdate: 'Services/WareHouse/EcoTaxesService.svc/Update',
            ManagmentEcotasasDelete: 'Services/WareHouse/EcoTaxesService.svc/Delete',
            ManagmentEcotasasAdd: 'Services/WareHouse/EcoTaxesService.svc/Add',
            ComboEcotasasGetAll: 'Services/WareHouse/EcoTaxesService.svc/GetAllByBrand',
            EcotasasGetByCode: 'Services/WareHouse/EcoTaxesService.svc/GetByCode',
            UrlComboTypeIva: 'Services/General/VatTypeService.svc/GetAll'
        },
        BONIFICACION: {
            BonosGetAll: 'Services/WareHouse/BonusesService.svc/GetAll',
            BonosUpdate: 'Services/WareHouse/BonusesService.svc/Update',
            BonosUpdateMovements: 'Services/WareHouse/BonusesService.svc/UpdateBonusMovements',
            BonosAdd: 'Services/WareHouse/BonusesService.svc/Add',
            BonosDelete: 'Services/WareHouse/BonusesService.svc/Delete',
            BonosGetByCode: 'Services/WareHouse/BonusesService.svc/GetByCode'
        }
    },
    BAJAS_MASIVAS: {
        STEP1: {
            urlGetfindUnsubscribedHistory: "Services/WareHouse/UnsubcribedMaterialService.svc/FindUnsubscribedHistory",
            urlGetUnsubscribedMaterialsById: "Services/WareHouse/UnsubcribedMaterialService.svc/GetUnsubscribedMaterialsById"
        },
        STEP2: {
            urlGetGetAllSuppliers: "Services/General/CustomerService.svc/GetAllSuppliers",
            urlGetMaterialsForUnsubscribe: "Services/WareHouse/UnsubcribedMaterialService.svc/GetMaterialsForUnsubscribePaged",
        },
        STEP3: {
            urlGetMaterialsForUnsubscribe: "Services/WareHouse/UnsubcribedMaterialService.svc/GetMaterialsForUnsubscribePaged"

        },
        STEP4: {
            urlGetRecepcionist: 'Services/WareHouse/ReceptionistService.svc/GetAll',
            urlInsert: "Services/WareHouse/UnsubcribedMaterialService.svc/Insert"
        }
    },
    INVENTARIO: {
        GetMeasureUnits: 'Services/WareHouse/WareHouseMaterialService.svc/GetMeasureUnits',
        STEP_1: {
            GetAllReceptionists: 'Services/WareHouse/ReceptionistService.svc/GetAll',
            GetByID: 'Services/WareHouse/InventoryService.svc/GetByID',
            GetOpenedMaterialInventories: 'Services/WareHouse/InventoryService.svc/GetOpenedMaterialInventories',
            GetClosedMaterialInventories: 'Services/WareHouse/InventoryService.svc/GetClosedMaterialInventories',
            GetDeletedMaterialInventories: 'Services/WareHouse/InventoryService.svc/GetDeletedMaterialInventories',
            CancelMaterialInventory: 'Services/WareHouse/InventoryService.svc/CancelMaterialInventory'

        },
        STEP_3: {
            FindMaterialsViewForInventory: 'Services/WareHouse/InventoryService.svc/FindMaterialsViewForInventory'
        },
        STEP_4: {
            GetByMaterialCodeWithDetails: 'Services/WareHouse/WareHouseMaterialService.svc/GetByMaterialCodeWithDetails'
        },
        STEP_5: {
            OpenMaterialInventory: 'Services/WareHouse/InventoryService.svc/OpenMaterialInventory'
        },
        STEP_6: {
            UpdateInventoryDetail: 'Services/WareHouse/InventoryService.svc/UpdateInventoryDetail '
        },
        STEP_7: {
            CloseMaterialInventory: 'Services/WareHouse/InventoryService.svc/CloseMaterialInventory',
            CloseMaterialInventoryByID: 'Services/WareHouse/InventoryService.svc/CloseMaterialInventoryByID'
        }
    },
    HOME: {
        OrderSummary: 'Services/WareHouse/WareHouseHomeService.svc/GetOrderResume',
        HomeGetPendingBillCounterSales: 'Services/Invoicing/HomeInvoicesService.svc/GetPendingBillCounterSales',
        IndexStock: 'Services/WareHouse/WareHouseHomeService.svc/GetStockStaticByIndex',
        StockByAccountingCode: 'Services/WareHouse/WareHouseHomeService.svc/GetStockStaticByAccountingCode',
        WareHouseHomeAlerts: 'Services/WareHouse/WareHouseHomeService.svc/GetHomeAlerts'
    }
}


